import React, { useState } from 'react';
import {
    PromotedEventsState,
    PromotedSportSingleType,
} from 'src/domains/layouts/webview/components/promotedSports/PromotedEventsState.state';
import { observer } from 'src/utils/mobx-react';
import { makeObservable, observable } from 'mobx';
import { CompetitionData } from './CompetitionData';
import { Collapse } from 'src/ui/components/collapse/sports/02/Collapse';
import { PromotedSportSectionContainer } from './PromotedSportSection.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { SdkCustomer } from 'src/domains/layouts/state/customer';

interface PromotedSportWrapperPropsType {
    sportSlug: string;
    sportData: PromotedSportSingleType;
    promotedEventsState: PromotedEventsState;
}

class State {
    @observable public isOpenedSport: boolean = true;

    public constructor() {
        makeObservable(this);
    }

    public setIsOpened = (): void => {
        this.isOpenedSport = !this.isOpenedSport;
    };
}

export const PromotedSportSectionWrapper = observer(
    'PromotedSportSectionWrapper',
    ({ sportSlug, sportData }: PromotedSportWrapperPropsType) => {
        const common = useCommon();
        const sdkCustomer = SdkCustomer.get(common);

        const [state] = useState(() => new State());

        const configState = ConfigComponents.get(common).config;
        const sportName = sdkCustomer.models.getSport(sportSlug)?.name ?? '';
        const competitionsSorted = sportData.competitions_list.sort((a, b) => a.display_order - b.display_order);
        return (
            <PromotedSportSectionContainer variant={configState.componentVariants.sportsbookVariant}>
                <Collapse
                    isOpen={state.isOpenedSport}
                    data-test='promoted-event-group'
                    handleToggle={state.setIsOpened}
                    title={sportName}
                    sportId={sportName}
                />
                {state.isOpenedSport ? (
                    <>
                        {competitionsSorted.map((competition) => (
                            <CompetitionData
                                key={competition.id}
                                sportSlug={sportSlug}
                                competition={competition}
                            />
                        ))}
                    </>
                ) : null}
            </PromotedSportSectionContainer>
        );
    }
);
